module.exports = __webpack_public_path__ + "img/more-c.11bf7229.svg";